export function transferNumber(positionUnit, elementUnit) {
    if (positionUnit < 0) {
        return ((positionUnit / 375 - elementUnit / 3 / 375) * 100).toFixed(2);
    } else {
        return ((positionUnit / 375) * 100).toFixed(2);
    }
}
